declare const I18n;


import React from "react";
import LearnersStatsTable from "@/components/tables/LearnersStatsTable";

export const LearnersStats: React.FC = () => {
  return (
    <div>
      <div className="resource-heading-container">
        <h2 className="section-heading">
          Learners Stats
        </h2>

      </div>
      <LearnersStatsTable />
    </div>)

};

export default LearnersStats;